import { YesNoEmpty } from '@interfaces/models';

import { TriageAccountType, TriageForm } from '../models';

export const updateAccountTypeBasedOnInheritanceQuestionAnswer = (
  formData: TriageForm,
): TriageForm => {
  const updatedFormData = { ...formData };

  if (formData.isInheritedAccount === YesNoEmpty.YES) {
    if (formData.accountType === TriageAccountType.TRADITIONAL_IRA) {
      updatedFormData.accountType = TriageAccountType.INHERITED_TRADITIONAL_IRA;
    }
    if (formData.accountType === TriageAccountType.ROTH_IRA) {
      updatedFormData.accountType = TriageAccountType.INHERITED_ROTH_IRA;
    }
  }

  return updatedFormData;
};
